import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureTypeFieldsRevisionSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId"
					to="/$organizationId/settings/procedure-types/$procedureTypeId/fields"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Fields
					</Button>
				</Link>
			}
		/>
	)
})
ProcedureTypeFieldsRevisionSettingsDetailViewTopBar.displayName = "ProcedureTypeFieldsRevisionSettingsDetailViewTopBar"
